import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const file = (props) => (
  <Icon viewBox="0 0 17 17" {...props}>
    <g>
      <title>attachment</title>
      <path d="M4.126 17c-1.03 0-2.093-.412-2.917-1.201a4.124 4.124 0 0 1 0-5.836L9.96 1.21a4.12 4.12 0 0 1 5.832 0 4.124 4.124 0 0 1 0 5.835l-.961-.96a2.757 2.757 0 0 0 0-3.88 2.753 2.753 0 0 0-3.877 0L2.17 10.96a2.757 2.757 0 0 0 0 3.878 2.753 2.753 0 0 0 3.877 0l5.832-5.835c.412-.412.412-1.064 0-1.442-.377-.377-1.063-.377-1.44 0L5.566 12.4l-.961-.96L9.443 6.6c.447-.447 1.064-.722 1.682-.722.617 0 1.235.24 1.68.721.893.893.927 2.369.07 3.33l-5.833 5.87A4.101 4.101 0 0 1 4.126 17z"
        fill="currentColor" fillRule="evenodd" />
    </g>
  </Icon>
);
/*eslint-enable */

export default file;



// WEBPACK FOOTER //
// ./chat-app/svgIcons/dist/components/file.js